import { fg } from '@atlassian/jira-feature-gating';

const JfindMatureExampleProject = {
	get(): boolean {
		return fg('jfind-gups-vc90-testing-gate');
	},
};

// eslint-disable-next-line import/no-default-export
export default JfindMatureExampleProject;
